import { Serializer } from 'jsonapi-serializer'

export default new Serializer('user', {
  attributes: [
    'firstName', 'lastName', 'email', 'tags', 'state', 'productUserGroup'
  ]
})
